import { useFullsizeCalculator } from '@/reducer/ensOptions';
import { useIsLg } from '../shared/EnsContainerObserver';

export const useFilterOnSide = () => {
  const isLargeScreen = !useIsLg();
  return useFullsizeCalculator() && isLargeScreen;
};
